import React, { createContext, useContext } from "react";
import useWebSocket from "../hooks/useWebSocket";

const WebSocketContext = createContext(null);

export function WebSocketProvider({ userId, children }) {
  const ws = useWebSocket(userId);
  return (
    <WebSocketContext.Provider value={ws}>
      {children}
    </WebSocketContext.Provider>
  );
}

export function useWS() {
  return useContext(WebSocketContext);
}
